import { render, staticRenderFns } from "./zspPalletManage.vue?vue&type=template&id=2a4a0dd9&scoped=true&"
import script from "./zspPalletManage.vue?vue&type=script&lang=js&"
export * from "./zspPalletManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a0dd9",
  null
  
)

export default component.exports